/* eslint-disable no-promise-executor-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
import axios from 'axios';

/**
 * Faz upload de arquivo para S3 usando presigned URL
 * @param {string} url - URL presigned da AWS
 * @param {File} file - Arquivo a ser enviado
 * @param {number} maxRetries - Número máximo de tentativas
 * @returns {Promise<boolean>} - true se sucesso
 */
export default async function uploadS3(url, file, maxRetries = 3) {
  let lastError;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
        timeout: 120000, // 2 minutos timeout
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      });

      // Valida status HTTP 200
      if (response.status === 200) {
        console.log(`✅ Upload bem-sucedido: ${file.name}`);
        return true;
      }

      throw new Error(`Status HTTP inválido: ${response.status}`);
    } catch (error) {
      lastError = error;
      console.error(
        `❌ Tentativa ${attempt}/${maxRetries} falhou para ${file.name}:`,
        error.message
      );

      // Se não é a última tentativa, aguarda antes de retry
      if (attempt < maxRetries) {
        const delay = Math.min(1000 * 2 ** attempt, 10000); // Exponential backoff (max 10s)
        console.log(`⏳ Aguardando ${delay}ms antes de tentar novamente...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }

  // Se chegou aqui, todas as tentativas falharam
  throw new Error(
    `Falha ao enviar ${file.name} após ${maxRetries} tentativas: ${lastError.message}`
  );
}
